export const types = {
  RESEND_VERIFICATION: 'verification'
};

